module.exports = __webpack_public_path__ + "img/database.66cbf319.svg";